import "./NavBar.css";
import logo from "../../assets/logotest.png";

function NavBar() {
  return (
    <nav className="navbar">
      <div className="navbar__brand">
        <img src={logo} alt="FNY Logo" className="navbar__logo" />
      </div>

      <div className="navbar__menu">
        <a href="#home">Home</a>
        <a href="#videos">Videos</a>
        <a href="#features">Features</a>
        <a href="#features">Contact</a>
      </div>
    </nav>
  );
}

export default NavBar;